import React from "react"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../hooks/UseStores"
import {useQuery} from "graphql-hooks"
import {GET_BRAND_POI} from "../../gql/gqlBrands"
import queryString from "query-string"
import {Spinner} from "../../components/Spinner/index"
import InternalError from "../../components/InternalError"
import {brandIdToSicCode} from "../../utils/utils"
import Locations from "../../components/Locations"

const LocationsTable = (props) => {
  const {navStore, timePeriodStore} = UseStores()

  const {brandId, geoType, geoId} = queryString.parse(props.location.search) // fetch query params
  let sicCode
  brandId && (sicCode = brandIdToSicCode(brandId))
  const geo = {geoType, geoId}
  const timePeriod = timePeriodStore.timePeriod

  const {loading, data, error} = useQuery(GET_BRAND_POI, {
    variables: {brandId, sicCode, geo, timePeriod},
  })

  navStore.setBrandId(parseInt(brandId))

  if (loading) return <Spinner />
  if (error) return <InternalError />

  return (
    <div className="brand-location-container">
      {data ? <Locations data={data.brand.pois} /> : ""}
    </div>
  )
}
export default observer(LocationsTable)
